import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';

import CountDown from 'components/CountDown/CountDown';
import MobileCountDown from 'components/CountDown/MobileCountDown';
import { useHistory } from 'react-router-dom';
import { homePath } from 'constant/route-path';

const CountDownWrapper = styled.div`
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    min-height: 660px;
    height: calc(100vh - 447px);
    background-image: url(${require('assets/images/count-down/bg.png')});
    background-color: #000;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        min-height: 845px;
        background-image: url(${require('assets/images/count-down/mobile-bg.png')});
    `};
`;

const CountDownContent = styled.div`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding-top: 0;
    `};
`;

const Header = styled.div`
    color: #fff;
    font-weight: 700;
    font-size: 60px;
    line-height: 80px;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        font-size: 42px;
        line-height: 57px;
    `};
`;

const SubHeader = styled(Header)`
    font-size: 52px;
    line-height: 70px;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        font-size: 32px;
        line-height: 43px;
    `};
`;

const Desc = styled.div`
    margin: 10px auto 20px;
    width: 580px;
    height: 44px;
    line-height: 44px;
    border-radius: 22px;
    background: rgba(0, 0, 0, 0.3);
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    text-align: center;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: auto;
        height: 30px;
        font-size: 12px;
        line-height: 30px;
        padding: 0 30px;
    `};
`;

const SubscribeWrapper = styled.div`
    display: flex;
    width: 580px;
    justify-content: space-between;
    align-items: center;
    margin-top: 50px;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        display: block;
        width: 100vw;
        margin-top: 63px;
        padding: 0 20px;
    `};
`;

const SubscribeLabel = styled.div`
    flex: 1;
    padding-right: 20px;
    color: #fbfcfe;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        margin-bottom: 20px;
        padding-right: 0;
    `};
`;

const SubscribeLabelTitle = styled.div`
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
`;

const SubscribeLabelDesc = styled.div`
    margin-top: 10px;
    font-size: 12px;
    font-weight: 400;
`;

const SubscribeButton = styled.a`
    display: block;
    width: 178px;
    height: 40px;
    line-height: 40px;
    background: #fad218;
    border-radius: 12px;
    color: #000;
    font-size: 14px;
    text-decoration: none;
    text-align: center;
`;

const targetDate = new Date(Date.UTC(2025, 0, 27, 14, 0, 0, 0));

function CountDownPage() {
    const isMobile = useMediaQuery('(max-width: 720px)');
    const history = useHistory();
    const location = useLocation();
    const onComplete = useCallback(() => {
        history.push({ pathname: homePath, search: location.search });
    }, [history, location.search]);

    useEffect(() => {
        if (Date.now() > targetDate.getTime()) {
            onComplete();
        }
    }, [onComplete]);

    return (
        <CountDownWrapper>
            <CountDownContent>
                <Header>GOAT One Piece{isMobile ? '' : ' Project'}</Header>
                <SubHeader>COMING SOON</SubHeader>
                <Desc>Growth, Community, Rewards</Desc>
                {isMobile ? (
                    <MobileCountDown targetDate={targetDate} onComplete={onComplete} />
                ) : (
                    <CountDown targetDate={targetDate} onComplete={onComplete} />
                )}
                <SubscribeWrapper>
                    <SubscribeLabel>
                        <SubscribeLabelTitle>Get Notified</SubscribeLabelTitle>
                        <SubscribeLabelDesc>
                            Be the first to know when GOAT One Piece campaign goes live
                        </SubscribeLabelDesc>
                    </SubscribeLabel>
                    <SubscribeButton
                        href="https://docs.google.com/forms/d/e/1FAIpQLSdJZw2Vk7RZgTXXC4HnuLuoofwpqKBFAxmwYj9zSuNAwoJSpg/viewform?usp=sf_link"
                        target="_blank"
                    >
                        Subscribe
                    </SubscribeButton>
                </SubscribeWrapper>
            </CountDownContent>
        </CountDownWrapper>
    );
}

export default observer(CountDownPage);
